export default __webpack_public_path__ + "static/media/fevr-bm-icon-5.7bbc0222.svg";